import { gql, TypedDocumentNode } from "@apollo/client";

export type PatScoreEditRegistration = {
  id: string;
  canceledAt?: string | null;
  event?: {
    slug?: string | null;
  } | null;
};

export type PatScoreEditRegistrationHistoryResponse = {
  eventRegistrationHistory: PatScoreEditRegistration[];
};

export type PatScoreEditRegistrationHistoryVariables = {
  pgaId: string;
};

export const PAT_SCORE_EDIT_REGISTRATION_HISTORY_QUERY: TypedDocumentNode<
  PatScoreEditRegistrationHistoryResponse,
  PatScoreEditRegistrationHistoryVariables
> = gql`
  query PatScoreEditRegistrationHistory($pgaId: String!) {
    eventRegistrationHistory(pgaId: $pgaId) {
      id
      canceledAt
      event {
        slug
      }
    }
  }
`;

export type PatScoreEditEventRegistrant = {
  id: string;
  pgaId?: string | null;
};

export type PatScoreEditEventRegistrantsResponse = {
  eventRegistrants: {
    edges: Array<{
      node: PatScoreEditEventRegistrant;
    }>;
  };
};

export type PatScoreEditEventRegistrantsVariables = {
  slug: string;
  search: string;
  first: number;
};

export const PAT_SCORE_EDIT_EVENT_REGISTRANTS_QUERY: TypedDocumentNode<
  PatScoreEditEventRegistrantsResponse,
  PatScoreEditEventRegistrantsVariables
> = gql`
  query PatScoreEditEventRegistrants($slug: String!, $search: String, $first: Int) {
    eventRegistrants(slug: $slug, search: $search, first: $first) {
      edges {
        node {
          id
          pgaId
        }
      }
    }
  }
`;
